import React from "react";
import styles from "./styles.module.scss";

const AdditionalComments = ({ comment, updateFormData, t }) => {
  return (
    <div className={styles.commentsSection}>
      <div className={styles.sectionHeader}>
        <h2 className={styles.title}>
          {t("booking.fullBookingPage.comments.title")}
        </h2>
      </div>
      
      <textarea 
        className={styles.commentInput} 
        placeholder={t("booking.fullBookingPage.comments.placeholder")}
        value={comment} 
        onChange={(e) => updateFormData({ comment: e.target.value })} 
        rows={4} 
      />
    </div>
  );
};

export default AdditionalComments;